import { useMemo } from "react";
import { CroppingPatternReportModel } from "@agroyaar/sdk";
import Title from "@/shared/components/report-template/presentation/components/common/Title";
import ReportTemplate from "@/shared/components/report-template/presentation/components/ReportTemplate";
import ColumnChart, {
  ColumnChartData,
} from "@/shared/components/charts/ColumnChart";
import { mapIndexToChartData } from "@/features/reports/presentation/components/cropping-pattern/utils/make-chart-data";

interface SoilAdaptabilityIndexProps {
  croppingPatternReports: CroppingPatternReportModel[];
  pageNumber: number;
}

const SoilAdaptabilityIndex = ({
  croppingPatternReports,
  pageNumber,
}: SoilAdaptabilityIndexProps) => {
  const soilChartData: ColumnChartData[] = useMemo(
    () => mapIndexToChartData(croppingPatternReports, "soilAdaptabilityIndex"),
    [croppingPatternReports]
  );

  const irrigationChartData: ColumnChartData[] = useMemo(
    () =>
      mapIndexToChartData(croppingPatternReports, "irrigationRequirementIndex"),
    [croppingPatternReports]
  );

  return (
    <ReportTemplate serviceType="CROPPING_PATTERN" pageNumber={pageNumber}>
      <div className="w-full flex flex-col justify-center items-start gap-2 my-2">
        <Title>سازگاری خاکی</Title>
        <div className="w-full flex flex-col justify-center items-center gap-3 my-2">
          <ColumnChart
            data={soilChartData}
            yAxisTitle="شاخص الگو کشت"
            height={300}
            decimalNumber={2}
          />
          <Title>سازگاری خاکی محصولات منتخب</Title>
        </div>
      </div>
      <div className="w-full flex flex-col justify-center items-start gap-2 my-2">
        <Title> شاخص الگوی کشت براساس نیاز خالص آبیاری</Title>
        <div className="w-full flex flex-col justify-center items-center gap-3 my-2">
          <ColumnChart
            data={irrigationChartData}
            yAxisTitle="شاخص الگو کشت"
            height={300}
            decimalNumber={2}
          />
          <Title> شاخص الگوی کشت - نیاز خالص آبیاری محصولات منتخب</Title>
        </div>
      </div>
    </ReportTemplate>
  );
};

export default SoilAdaptabilityIndex;
